module.exports = __webpack_public_path__ + "img/ico_coinstore_watch&earn@3x.188cce72.png";